import { financeFormInputStorage } from '@dxp-module/common'
import IDimensions from '../../../../../modules/common/src/interfaces/IDimensions'
import { FinanceFormType } from '../graphql/__generated__/graphql.autogenerated'

export const isCurrentInputCash = (dimensions: IDimensions): boolean => {
  const input = financeFormInputStorage.get(dimensions)
  return !input || input?.paymentType === FinanceFormType.Cash
}
